import { createContext, useContext, useEffect, useState, useCallback } from "react";
import api from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=checking, false=guest, obj=user
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    const token = localStorage.getItem("attendly_token");
    if (!token) { setUser(false); return; }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      localStorage.removeItem("attendly_token");
      setUser(false);
    }
  }, []);

  useEffect(() => { load(); }, [load]);

  const login = async (identifier, password) => {
    setError("");
    try {
      const { data } = await api.post("/auth/login", { identifier, password });
      localStorage.setItem("attendly_token", data.token);
      setUser(data.user);
      return data.user;
    } catch (e) {
      const msg = e?.response?.data?.detail || "Login failed";
      setError(typeof msg === "string" ? msg : "Login failed");
      throw e;
    }
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (_) {}
    localStorage.removeItem("attendly_token");
    setUser(false);
    window.location.href = "/login";
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, error, reload: load }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
